module.exports = fox._r("images/gallery/icons.png", __webpack_public_path__ + "_/_/_/root/images/gallery/icons.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/gallery/icons.png
// module id = 431
// module chunks = 4